import { FC, ReactNode } from 'react';

export const SubscriptionLayout: FC<{
  title: ReactNode;
  subtitle: ReactNode;
  subscriptionCards: ReactNode;
  logo: ReactNode;
  faq: ReactNode;
}> = ({ title, subtitle, subscriptionCards, logo, faq }) => {
  return (
    <section className="pt-[30px]">
      <div className="text-text300 relative px-0 text-base">
        <div className="relative z-0 overflow-clip rounded-[10px]">
          <div className="absolute inset-0 -z-10 bg-[url('/assets/images/subscription/subscription-widget-bg-x1.webp')] bg-cover bg-center bg-no-repeat md:bg-[url('/assets/images/subscription/subscription-widget-bg-x2.webp')] lg:bg-[url('/assets/images/subscription/subscription-widget-bg-x3.webp')]" />
          <div className="bg-gradient from-back300 to-back300 absolute inset-0 -z-10 bg-gradient-to-r via-white/0" />
          <div className="z-1 w-full pb-[80px] pt-8">
            {title}
            {subtitle}
            <div className="flex w-full items-center justify-center pt-8">
              {subscriptionCards}
            </div>
          </div>
        </div>
        <div className="absolute right-1/2 top-0 -translate-y-5 translate-x-1/2">
          {logo}
        </div>
      </div>

      {faq}
    </section>
  );
};
